import { createTheme } from '@mantine/core';

export const theme = createTheme({
  primaryColor: 'dark',
  colors: {
    // You can override existing colors or add new ones
    brand: [
      '#f0f9ff',
      '#e0f2fe',
      '#bae6fd',
      '#7dd3fc',
      '#38bdf8',
      '#0ea5e9',
      '#0284c7',
      '#0369a1',
      '#075985',
      '#0c4a6e',
    ],
  },
  // You can also customize other theme aspects
  fontFamily: 'Inter, sans-serif',
  radius: {
    xs: '4px',
    sm: '6px',
    md: '8px',
    lg: '12px',
    xl: '16px',
  },
});
